import { serviceMaker, methods, api } from "@/http/index.js";

export const getReportsData = () =>
  serviceMaker(`/reports`, methods.GET, api.NGB);
export const getReportsTemplateData = () =>
  serviceMaker(`/reports/template`, methods.GET, api.NGB);
export const createreports = (data) =>
  serviceMaker(`/reports`, methods.POST, api.NGB, data);
export const getReportsWithTemplate = (id) =>
  serviceMaker(`/reports/${id}?template=true`, methods.GET, api.NGB);
export const updatereports = (id, data) =>
  serviceMaker(`/reports/${id}`, methods.PUT, api.NGB, data);
export const getreports = (id) =>
  serviceMaker(`/reports/${id}`, methods.GET, api.NGB);
export const deletereports = (id) =>
  serviceMaker(`/reports/${id}`, methods.DELETE, api.NGB);
